/** @format */

import React from 'react';
import { AddVendorsForm } from '../components/AddVendorsForm';

/**
 * AddVendorsFormContainer
 * Container component for AddVendorsForm
 * Handles form state and submissions
 */
export const AddVendorsFormContainer: React.FC = () => {
  return <AddVendorsForm />;
};
